import Vue from 'vue'

import VueMasonry from 'vue-masonry-css'

import { LayoutsPlugin } from './layouts/layouts'
import { ComponentsPlugin } from "./components/components";
import { M2hPagePlugin } from "@/page-elements/page-elements";
import VueToast from "vue-toast-notification";
import 'vue-toast-notification/dist/theme-sugar.css';
import AsyncComputed from "vue-async-computed";

Vue.use(LayoutsPlugin)
Vue.use(ComponentsPlugin)
Vue.use(M2hPagePlugin)

Vue.use(VueMasonry);
Vue.use(AsyncComputed);
Vue.use(VueToast);

const moment = require('moment')
require('moment/locale/nl')
require('moment/locale/nl-be')

Vue.use(require('vue-moment'),{moment});

import VueMask from 'v-mask';

Vue.use(VueMask);

Vue.config.productionTip = false


if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
}
